import React from "react";

// NOTE: NSAI-4950 — the Matrix logo mark. `currentColor` so it follows the
// surrounding text in both themes, like the other integration icons here.
export const Matrix: React.FC<React.SVGProps<SVGSVGElement>> = React.memo(
  (props) => (
    <svg
      viewBox="0 0 27.9 32"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M.93 1.24v29.52h2.13V32H0V0h3.06v1.24H.93zM8.28 10.1v1.55h.04a4.4 4.4 0 0 1 1.46-1.38 3.8 3.8 0 0 1 1.93-.48 4.4 4.4 0 0 1 1.9.4c.56.28 1 .76 1.28 1.5a4.34 4.34 0 0 1 1.34-1.34 3.6 3.6 0 0 1 2-.56 5.9 5.9 0 0 1 1.62.21c.48.14.9.37 1.24.68.34.32.6.73.8 1.24.18.5.28 1.12.28 1.83v7.42h-3.03v-6.29c0-.37-.01-.72-.04-1.05a2.26 2.26 0 0 0-.23-.85 1.4 1.4 0 0 0-.55-.57 1.98 1.98 0 0 0-.98-.21c-.42 0-.76.08-1.02.24a1.7 1.7 0 0 0-.6.63c-.15.26-.24.55-.29.88-.04.33-.06.66-.06 1v6.22h-3.03v-6.22c0-.33 0-.65-.02-.97a2.63 2.63 0 0 0-.18-.89 1.33 1.33 0 0 0-.52-.65 1.9 1.9 0 0 0-1.06-.24c-.14 0-.32.03-.55.1a1.9 1.9 0 0 0-.66.36c-.21.18-.4.44-.55.78-.15.34-.23.79-.23 1.34v6.39H5.55V10.1h2.73zM27 30.76V1.24h-2.13V0h3.06v32h-3.06v-1.24H27z" />
    </svg>
  ),
);

Matrix.displayName = "Matrix";
